import { render } from "./VgtHeaderRow.vue?vue&type=template&id=f84a9800"
import script from "./VgtHeaderRow.vue?vue&type=script&lang=js"
export * from "./VgtHeaderRow.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__